export enum KYC_STATUS  {
    SUBMISSION_REQUIRED = 0,
    PENDING = 1,
    VERIFIED = 2,
    CANCELLED = 3
}